export class Accesories {
    	/*1*/ 	public id: number;


	constructor(u ?: any) {
		this.id = u ? u.id : null;
	}
}
